<template>
  <section class="cards-view">
    <div
      class="absolute-wrapper"
      :class="{
        visible: (formActive && activeFlat) || fetchingFlats,
      }"
    >
      <div
        v-if="(formActive && activeFlat) || fetchingFlats"
        class="absolute-wrapper__inner"
        :class="{ active: fetchingFlats }"
      >
        <transition name="fade">
          <Loader
            v-if="fetchingFlats"
            text="Ładowanie mieszkań"
            :spinner="true"
            :zIndex="100"
          ></Loader>
        </transition>
        <transition name="fade">
          <div class="cards-form">
            <flat-form
              v-if="formActive && activeFlat"
              :flat="activeFlat"
              @close="toggleForm"
            ></flat-form>
          </div>
        </transition>
      </div>
    </div>
    <div v-if="!fetchingFlats" class="cards-view__filters-wrapper">
      <div class="cards-view__filters">
        <div class="cards-view__filters-row">
          <Select
            :property="flatProperties['rooms']"
            :heading="$t('rooms')"
            @handler="handleRooms"
            queryParam="s_pokoje"
          ></Select>
          <Select
            :property="flatProperties['floor']"
            :heading="$t('singleFlat.floor')"
            @handler="handleFloors"
            queryParam="s_pietro"
          ></Select>
        </div>
        <div class="cards-view__filters-row">
          <Slider
            :property="flatProperties['area']"
            :title="$t('singleFlat.area')"
            units="m"
            :lazy="lazy"
            :horizontal="true"
            fixed="0"
            queryParam="s_metry"
          ></Slider>
          <!-- <Slider
            :property="flatProperties['price']"
            title="Cena"
            units="PLN"
            :lazy="lazy"
            :horizontal="true"
            fixed="0"
          ></Slider> -->
        </div>
      </div>
      <div class="info-wrapper">
        <p v-if="filteredFlats.length > 0" class="cards-view__filter-info">
          {{ $t('matchingFlatsInfo') }}: <b>{{ filteredFlats.length }}</b>
        </p>
        <p v-else class="cards-view__filter-info">
          {{ $t('favourites.noCriteria') }}
        </p>

        <div class="view-buttons-wrapper">
          <button
            @click="() => (currentView = 'cards')"
            class="view-button"
            :class="{ active: currentView === 'cards' }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="29"
              viewBox="0 0 35 34"
            >
              <g class="a">
                <rect class="b" width="15" height="15" />
                <rect class="c" x="1" y="1" width="13" height="13" />
              </g>
              <g class="a" transform="translate(0 19)">
                <rect class="b" width="15" height="15" />
                <rect class="c" x="1" y="1" width="13" height="13" />
              </g>
              <g class="a" transform="translate(20)">
                <rect class="b" width="15" height="15" />
                <rect class="c" x="1" y="1" width="13" height="13" />
              </g>
              <g class="a" transform="translate(20 19)">
                <rect class="b" width="15" height="15" />
                <rect class="c" x="1" y="1" width="13" height="13" />
              </g>
            </svg>
            <span>{{ $t('cardsView') }}</span>
          </button>
          <button
            @click="() => (currentView = 'list')"
            class="view-button"
            :class="{ active: currentView === 'list' }"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="18"
              viewBox="0 0 35 22"
            >
              <rect class="d" width="4" height="4" />
              <rect class="d" width="4" height="4" transform="translate(0 9)" />
              <rect
                class="d"
                width="4"
                height="4"
                transform="translate(0 18)"
              />
              <rect class="d" width="27" height="4" transform="translate(8)" />
              <rect
                class="d"
                width="27"
                height="4"
                transform="translate(8 9)"
              />
              <rect
                class="d"
                width="27"
                height="4"
                transform="translate(8 18)"
              />
            </svg>
            <span>{{ $t('listView') }}</span>
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="!fetchingFlats && currentView === 'cards'"
      class="cards-view__grid"
    >
      <FlatCard
        v-for="flat in visibleFlats"
        :key="flat.investments_number"
        :flat="flat"
        @toggleForm="toggleForm"
        @changeFlat="changeFlat"
        :withButtons="true"
      ></FlatCard>
    </div>
    <Table
      v-else-if="!fetchingFlats && currentView === 'list'"
      :flats="filteredFlats"
      @toggleForm="toggleForm"
    />
    <div
      v-if="
        visibleFlats.length < filteredFlats.length && currentView === 'cards'
      "
      class="cards-view__load-more"
    >
      <button @click="loadMore">{{ $t('loadMore') }}</button>
    </div>
  </section>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
// import FlatCardWrapper from '@/components/flat/flat-card-wrapper';
import FlatCard from '@/components/flat/flat-card-list';
import FlatForm from '@/components/flat/flat-form';
import Loader from '@/components/loader.vue';
import Table from '@/components/list.vue';
import Slider from '@/components/form/range-slider.vue';
import Select from '@/components/form/select.vue';

export default {
  name: 'Cards',
  components: {
    // FlatCardWrapper,
    FlatForm,
    Slider,
    Select,
    Loader,
    FlatCard,
    Table,
  },
  data() {
    return {
      formActive: false,
      saleOnly: false,
      currentView: 'cards',
      selectedRooms: [],
      selectedFloors: [],
      activeFlat: null,
      cardsToShow: 6,
    };
  },
  computed: {
    ...mapState({
      flatProperties: state => state.browser.flatProperties,
      fetchingFlats: state => state.browser.fetchingFlats,
    }),
    ...mapGetters({
      flats: 'GET_FLATS',
      filteredFlatsNotSold: 'GET_FILTERED_FLATS',
    }),
    flatsToFilter() {
      return this.filteredFlatsNotSold.filter(
        flat =>
          flat[this.flatProperties['type']] === 'Mieszkanie' &&
          flat[this.flatProperties['status']] !== '3' &&
          Number(flat[this.flatProperties['rooms']]) > 0
      );
    },
    filteredFlats() {
      return this.flatsToFilter.filter(
        flat =>
          (this.selectedRooms.length === 0 ||
            this.selectedRooms.includes(
              Number(flat[this.flatProperties['rooms']])
            )) &&
          (this.selectedFloors.length === 0 ||
            this.selectedFloors.includes(
              Number(flat[this.flatProperties['floor']])
            ))
      );
    },
    visibleFlats() {
      return this.filteredFlats.slice(0, this.cardsToShow);
    },
    minFloor() {
      const floors = this.flatsToFilter.map(
        el => el[this.flatProperties['floor']]
      );
      if (floors.length === 0) return 0;
      return Math.min(...floors);
    },
    maxFloor() {
      const floors = this.flatsToFilter.map(
        el => el[this.flatProperties['floor']]
      );
      if (floors.length === 0) return 0;
      return Math.max(...floors);
    },
  },
  methods: {
    toggleSaleOnly(e) {
      this.saleOnly = e.target.checked;
    },
    getFlatById(id) {
      for (let flat of this.flats) {
        if (flat[this.flatProperties['id']].toUpperCase() == id.toUpperCase()) {
          return flat;
        }
      }
    },
    handleRooms(rooms) {
      this.selectedRooms = rooms;
    },
    handleFloors(floors) {
      this.selectedFloors = floors;
    },
    toggleForm(flat = null) {
      window.top.postMessage(`TOGGLE_MODAL`, '*');
      this.formActive = !this.formActive;
      if (this.activeFlat) this.activeFlat = null;
      else this.activeFlat = flat;
    },
    loadMore() {
      this.cardsToShow = this.cardsToShow + 6;
    },
  },
};
</script>

<style scoped lang="scss">
.absolute-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  max-height: 100vh;
  z-index: 35;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  visibility: hidden;
  opacity: 0;
  &__inner {
    max-height: 100%;
    overflow-y: auto;
    &.active {
      position: relative;
      width: 100%;
      height: 100%;
    }
  }
  &.visible {
    visibility: visible;
    opacity: 1;
  }
}

.info-wrapper {
  display: flex;
  margin-bottom: 30px;
  flex-direction: column;
  @media (min-width: 1200px) {
    margin-top: -15px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
}

.checkbox-wrapper {
  margin: -45px 0 0 0;
  @media (max-width: 575px) {
    margin: -22px 0 12px 0;
  }
  /deep/ .checkbox__label {
    font-size: 16px;
    margin-top: 4px;
  }
}
.cards-view {
  padding: 40px 20px;
  width: 100%;
  max-width: 1340px;
  margin: 0 auto;
  &__load-more {
    width: 100%;
    margin: 50px 0 10px;
    display: flex;
    justify-content: center;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 15px 40px;
      border: 1px solid $primaryColor;
      font-family: 'Montserrat', sans-serif;
      background: transparent;
      cursor: pointer;
      font-size: 16px;
      transition: 0.3s;
      color: #000;
      &:hover {
        background: $primaryColor;
        color: #fff;
      }
    }
  }
  &__filters-wrapper {
    display: flex;
    flex-direction: column;
  }
  &__filters {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 20px 0;
    @media (max-width: 576px) {
      margin: 10px 0 20px;
    }
    @media (min-width: 576px) {
      flex-direction: row;
      & > div {
        margin: 0;
        &:not(:last-child) {
          margin-right: 30px;
        }
      }
    }
  }
  &__filters-row {
    display: flex;
    flex-direction: column;
    width: 100%;
    & > div {
      margin-bottom: 20px;
    }
    @media (max-width: 576px) {
      & > div:not(:last-child) {
        margin-bottom: 15px;
      }
    }
    @media (min-width: 1200px) {
      flex-direction: row;
      div:not(:first-child) {
        margin-left: 30px;
      }
    }
  }
  &__grid {
    display: grid;
    gap: 30px;
    grid-template-columns: repeat(1, 1fr);
    @supports not (gap: 30px) {
      & > div:not(:last-child) {
        margin-bottom: 30px;
      }
    }
    @media (min-width: 576px) {
      grid-template-columns: repeat(2, 1fr);
    }
    @media (min-width: 992px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

.view-buttons-wrapper {
  display: flex;
  align-items: center;
  margin-top: 20px;
  @media (min-width: 992px) {
    margin-top: 0;
    margin-left: 40px;
  }
}

.view-button {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px 20px;
  width: 100%;
  min-width: 130px;
  max-width: 190px;
  height: 66px;
  transition: 0.3s;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  @media (min-width: 440px) {
    margin-left: 5px;
  }
  &:hover {
    background: #f7f7f7;
    border-color: $lighterGray;
  }
  svg {
    fill: #e8e8ea;
    transition: 0.3s;
  }
  span {
    font-size: 14px;
    white-space: nowrap;
    margin-left: 9px;
    @media (min-width: 556px) {
      margin-left: 12px;
      font-size: 15px;
    }
  }
  .d {
    fill: #888;
    transition: 0.3s;
  }
  .a,
  .c {
    fill: none;
  }
  .a {
    stroke: #888;
    transition: 0.3s;
    stroke-width: 2px;
  }
  .b {
    stroke: none;
  }
  &.active {
    background: #fff5ed;
    border-color: #fff5ed;
    &:hover {
      background: #fff5ed;
    }
    .d {
      fill: $primaryColor;
    }
    .a {
      stroke: $primaryColor;
    }
  }
}

.cards-form {
  position: relative;
  width: 100%;
  max-width: 340px;
  min-height: 550px;
  border: 1px solid $primaryColor;
  background: #fff;
  overflow: hidden;
  & > form {
    position: static;
    top: auto;
    transform: none;
    min-width: 100% !important;
    right: auto;
    box-shadow: none;
  }
}
</style>
